import { createSignal, onCleanup } from 'solid-js'

// iOS-Safari-toolbar-style visibility: scrolling down hides, scrolling up
// shows, and the top of the page always shows. Deltas accumulate until they
// cross the threshold (lastY only advances then), so a slow scroll still
// flips the state while sub-threshold jitter doesn't. Rubber-band overscroll
// (negative scrollY / past the bottom) is clamped away so the bounce doesn't
// flicker the state.
export function createScrollDirectionVisibility(threshold = 12) {
  const [visible, setVisible] = createSignal(true)
  let lastY = window.scrollY

  const onScroll = () => {
    const maxY = Math.max(
      document.documentElement.scrollHeight - window.innerHeight,
      0,
    )
    const y = Math.min(Math.max(window.scrollY, 0), maxY)
    if (y <= 0) {
      setVisible(true)
      lastY = 0
      return
    }
    const delta = y - lastY
    if (Math.abs(delta) < threshold) return
    setVisible(delta < 0)
    lastY = y
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  onCleanup(() => window.removeEventListener('scroll', onScroll))

  return visible
}
